export const getSublineCategoryByCampaign = state => state.myloungeMetadata.categorySubline || {};

export const getCampaignSublineCategory = (state, campaignId) => getSublineCategoryByCampaign(state)[campaignId] || [];
